import styled from 'styled-components';
import { spacing, media } from '../theme';
import { Heading1, Heading2, Heading3, Heading4 } from '../theme/headings';

export const OntarioRow = styled.div`
  margin: 0 auto;
  max-width: 72rem;
  width: 100%;
`;

export const OntarioColumn = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding-left: ${spacing.spacing4};
  padding-right: ${spacing.spacing4};
`;

export const OntarioFormGroup = styled.div`
  &:last-of-type {
    margin-bottom: 3rem;
  }
`;

export const LeadTextParagraph = styled.p`
  font-size: 20px;
  line-height: 1.6;
  font-family: Open Sans;
  text-rendering: optimizeLegibility;

  @media ${media.small} {
    font-size: 1.375rem;
  }
`;

export const TextParagraph = styled.p`
  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  text-rendering: optimizeLegibility;

  & + ul {
    margin-top: -${spacing.spacing3};
  }

  & + ${Heading1}, & + ${Heading2}, & + ${Heading3}, & + ${Heading4} {
    margin-top: ${spacing.spacing6};
  }
`;

export const UnorderedList = styled.ul`
  padding: 0;
  list-style: disc;
  margin-left: ${spacing.spacing6};

  li {
    padding: 0 0 ${spacing.spacing3} 0;

    &:last-child {
      padding-bottom: 0;
    }
  }

  ul {
    margin: ${spacing.spacing2} 0 ${spacing.spacing2} ${spacing.spacing6};
  }

  & + ${Heading1}, & + ${Heading2}, & + ${Heading3}, & + ${Heading4} {
    margin-top: ${spacing.spacing6};
  }

  @media ${media.small} {
    margin: ${spacing.spacing2} 0 ${spacing.spacing5} ${spacing.spacing8};

    ul {
      margin: ${spacing.spacing2} 0 ${spacing.spacing2} ${spacing.spacing8};
    }
  }
`;
